var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74316 1.04193C4.79254 0.988086 4.85257 0.945097 4.91944 0.915688C4.98631 0.88628 5.05857 0.871094 5.13162 0.871094C5.20468 0.871094 5.27693 0.88628 5.3438 0.915688C5.41068 0.945097 5.47071 0.988086 5.52008 1.04193L10.1194 6.05979C10.1893 6.13508 10.2356 6.22912 10.2527 6.33037C10.2698 6.43162 10.257 6.53566 10.2158 6.62972C10.1746 6.72377 10.1068 6.80374 10.0208 6.8598C9.93472 6.91587 9.83419 6.94558 9.7315 6.94529H0.532793C0.430429 6.94541 0.330247 6.91571 0.244481 6.85983C0.158714 6.80395 0.0910752 6.7243 0.049823 6.63062C0.00857076 6.53694 -0.00450945 6.43327 0.0121796 6.33227C0.0288687 6.23128 0.0746049 6.13733 0.143803 6.0619L4.74316 1.04193Z",
    fill: "url(#paint0_linear_45_2081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2081",
    x1: 0.00512695,
    y1: 3.90819,
    x2: 10.2601,
    y2: 3.90819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2ec73e78f4841c95f44064d7c7a3926c.svg";
export { ForwardRef as ReactComponent };